// extracted by mini-css-extract-plugin
export default {"buttonlocation":"Button_buttonlocation__7PEC9"};